import { 
    AutocompleteInput, Create, CreateButton, Datagrid, DateField, DateInput, Edit, EditButton, ExportButton,
    FilterButton,
    FilterList, FilterListItem, FormDataConsumer, ImageField, List, ReferenceField, ReferenceInput,  
    SearchInput,  
    SimpleForm, TextField, TextInput, TopToolbar, downloadCSV, useNotify, useRedirect } from "react-admin";
import { ManutenzioneEseguita } from "./ImpiantiReferenceManutenzioni";
import { ItasToolbar } from "./util/ItasToolbar";
import { ItasEditActions } from "./util/ItasEditActions";
import { CustomPagination, addMonths, required } from "./util/generic";
import { Card, CardContent, Chip } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import HandymanIcon from '@mui/icons-material/Handyman';
import jsonExport from 'jsonexport/dist';
import axios from "axios";

const listFilters = [
    <SearchInput placeholder="Cerca per ID Impianto" source="q" alwaysOn />,
    <DateInput label="Data prevista maggiore di" source="gg_start"  />,
    <DateInput label="Data prevista minore di" source="gg_end"  />,
    <Chip label="Prossimi 3 mesi"  source="data_prevista_lte" defaultValue={addMonths(new Date(), 3).toISOString()} />,
];

function isEmpty(obj) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }
  
    return true;
  }
/*todo qui dobbiamo andare a prendere tutti record della persona vedi il xls per capire meglio */
const exporter = () => {
    const headers = {
        'Authorization': window.localStorage.auth.split("\"")[3]
      }
    var filterToRequest
    if(window.localStorage.getItem("RaStore.manutenzioni.listParams")){
        if(!(isEmpty(JSON.parse(window.localStorage.getItem("RaStore.manutenzioni.listParams")).filter)))
            filterToRequest = JSON.parse(window.localStorage.getItem("RaStore.manutenzioni.listParams")).filter
    }
    console.log("FILTER TO REQUEST: ",filterToRequest)
    axios.get("https://muttinservice.it/manutenzioni?export", {
        headers: headers,
        params:  filterToRequest ? filterToRequest : ""
    })
    .then(({data}) => {
        /* ESPORTAZIONE IN CSV */
        /* modeling the data passed from the backend */
        const dataExport = data.map(row => {  
             return {
                "Data Prevista": new Date(row.data), 
                "Città Utente" : row.utenteCitta,
                "Via Utente": row.utenteVia,
                "Prov. Utente": row.utenteProvincia,
                "Nome Utente": row.utenteNome,
                "Tel1 Utente": row.utenteTelefono1,
                "Tel2 Utente": row.utenteTelefono2,
                "Modello": row.modello,
                "Num.Serie": row.numeroSerie,
                "Cod. Man.": row.codiceManutenzione,
                "Desc. Man": row.descrizioneManutenzione,
                "Città Proprietario" : row.proprietarioCitta,
                "Via Proprietario": row.proprietarioVia,
                "Prov. Proprietario": row.proprietarioProvincia,
                "Nome Proprietario": row.proprietarioNome,
                "Tel1 Proprietario": row.proprietarioTelefono1,
                "Tel2 Proprietario": row.proprietarioTelefono2,
                "Note": row.note
            }
        });
        return jsonExport(dataExport, {
            rowDelimiter: ',',
        }, (err, csv) => {
            downloadCSV('\ufeff'+csv, 'manutenzioni-'+new Date().toISOString().split("T")[0], );
        });
    })
    .catch((error) => {
        console.log("Errore: ", error)
    })
    
    
};
const ListActions = () => (
    <TopToolbar>
        <FilterButton/>
        <CreateButton label="Crea nuova manutenzione"/>
        <ExportButton label="Esporta dati" exporter={exporter} maxResults={40000}/>
    </TopToolbar>
)
const postRowStyle = (record, index) => ({
    backgroundColor: record.data_eseguita === "0000-00-00" && !(record?.note?.includes("annulla"))? '#f7c436' : 'white',
});

export const ManutenzioniForm = () => {
    return (
        <SimpleForm 
        mode="onBlur" 
        reValidateMode="onBlur"
        toolbar={<ItasToolbar />}>
        <ReferenceInput source="id_tabella_manutenzioni" reference="tabella_manutenzioni" >
            <AutocompleteInput label="Tipologia" optionText="descrizione" fullWidth validate={required()}/>
        </ReferenceInput>
        <ReferenceInput source="id_impianto" reference="impianti" >
            <AutocompleteInput label="Impianto" optionText="descrizione" fullWidth validate={required()}/>
        </ReferenceInput>
        <FormDataConsumer>
        {({ formData }) =>
            formData.id_impianto ? (
            <ReferenceInput
                source="id_prodotto"
                reference="prodotti"
                filter={{ id_impianto: formData.id_impianto }}
                label="Prodotto"
            >
             <AutocompleteInput label="Prodotto" optionText="marca" fullWidth validate={required()}/>
            </ReferenceInput>
            ) : null
        }
        </FormDataConsumer>
        
        <DateInput source="data_prevista" fullWidth validate={required()} />
        <DateInput source="data_eseguita" defaultValue={"0000-00-00"} fullWidth />
        <TextInput source="note"        fullWidth />
        </SimpleForm>
    )
}

export const ManutenzioniEdit = () => {
    const notify = useNotify();

    function notyifyAndRedirect (action) {
        notify(`Record ${action}!`, { type: 'success' });
        window.history.go(-1)
    }

    const onSuccess = () => {
        notyifyAndRedirect("aggiornato")
    };
    const onDelete = () => {
        notyifyAndRedirect("eliminato")
    };
    return (
        <Edit mutationOptions={{ onSuccess, onDelete }}
            actions={<ItasEditActions />}
            mutationMode="optimistic"
            title="Modifica dettagli manutenzione"
            >
            <ManutenzioniForm />
        </Edit>
    );
}
export const ManutenzioniCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Manutenzioni programmata aggiunta`, { type: 'success' });
        redirect(`/manutenzioni`);
    };
    return (
        <Create 
        mutationOptions={{ onSuccess }}
        title="Aggiungi nuova manutenzione">
        <ItasEditActions />
        <ManutenzioniForm />
        </Create>
    );
}

export const ManutenzioniFilterSidebar = () => (
    
    <Card  sx={{ order: -1, mr: 2, mt: 8, width: 300 }}>
        <CardContent>
            <FilterList label="Prossimi interventi" icon={<CalendarMonthIcon />} >
                <FilterListItem label="1 mese" value={{ data_prevista_lte: addMonths(new Date(), 1).toISOString() }} />
                <FilterListItem label="3 mesi" value={{ data_prevista_lte: addMonths(new Date(), 3).toISOString() }} />
                <FilterListItem label="6 mesi" value={{ data_prevista_lte: addMonths(new Date(), 6).toISOString() }} />
            </FilterList>
        </CardContent>
    </Card>
);

export const ManutenzioniList = () => (
        <List
            sort={{ field: 'data_prevista', order: 'DESC' }}
            perPage={12}
            pagination={<CustomPagination />}
            actions={<ListActions />}
            filters={listFilters}
        >
        <Datagrid rowStyle={postRowStyle}>
            <TextField source="id_impianto" label="ID Impianto" />
            <ReferenceField label="Impianto" source="id_impianto" reference="impianti">
                <TextField source="descrizione" />
            </ReferenceField>
            <ReferenceField label="Prodotto" source="id_prodotto" reference="prodotti">
                <ImageField>
                    <HandymanIcon/>
                </ImageField>
            </ReferenceField>
            <ReferenceField label="Utente" source="id_impianto" reference="impianti" link={false}>
                <ReferenceField  source="id_utente" reference="persone">
                    <ImageField>
                        <PersonIcon/>
                    </ImageField>
                </ReferenceField>
            </ReferenceField>
           
            <ReferenceField label="Proprietario" source="id_impianto" reference="impianti" link={false}>
                <ReferenceField  source="id_utente" reference="persone">
                    <ImageField>
                        <PersonIcon/>
                    </ImageField>
                </ReferenceField>
            </ReferenceField>
            
            <ReferenceField label="Tipologia" source="id_tabella_manutenzioni" reference="tabella_manutenzioni" >
                <TextField  source="descrizione" />
                
            </ReferenceField>
            <ReferenceField label="Periodo (mesi)" source="id_tabella_manutenzioni" reference="tabella_manutenzioni" >
                <TextField  source="periodo" />
            </ReferenceField>
            <DateField source='data_prevista'/>
            <ManutenzioneEseguita source='data_eseguita'/>
            <TextField source="note" />
            
            <EditButton label="" />
        </Datagrid>
        </List>
    
);